import React, { useEffect, useMemo, useRef } from 'react'

import { useSelector } from 'react-redux'

import { ApplicationState } from '@store/types'
import { Loading, Header } from '@atoms'
import { BridgeService } from '@services/bridge'
import Tag from '@utils/Tag'
import useTrackingRefin from '@hooks/useTrackingRefin'
import { StepRefin } from '@utils/enums'

import { PageVisualizarPdf, PdfGrid } from './styles'
import Autorizacao from './Autorizacao'
import Ccb from './CCB'
import DeclaracaoResidencia from './DeclaracaoResidencia'
import SeguroPrestamista from './SeguroPrestamista'
import SeguroPrestamistaInss from './SeguroPrestamistaInss'
import CCBExercito from './CCBExercito'
import PublicoVulneravel from './PublicoVulneravel'
import ADF from './ADF'
import Portabilidade from './Portabilidade'
import Refinanciamento from './Refinanciamento'
import CapaCCB from './CapaCCB'
import SeguroPrestamistaRefin from './SeguroPrestamistaRefin'
import AutorizacaoLiquidacao from './AutorizacaoLiquidacao'
import CCBCtps from './CCBCtps'
import CartilhaCreditoTrabalhador from './CartilhaCreditoTrabalhador'

const VisualizadorTermo = () => {
  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)
  const ref = useRef<HTMLDivElement>(null)

  useTrackingRefin(StepRefin.TERMO_VISUALIZACAO)

  const PdfAssinatura = useMemo(
    () => ({
      AUTORIZACAO_CONSULTA_MARGEM: <Autorizacao />,
      CCB: <Ccb />,
      DECLARACAO_RESIDENCIA: <DeclaracaoResidencia />,
      SEGURO_PRESTAMISTA: <SeguroPrestamista />,
      SEGURO_PRESTAMISTA_INSS: <SeguroPrestamistaInss />,
      CCB_EXERCITO: <CCBExercito />,
      ADF: <ADF />,
      TERMO_PORTABILIDADE: <Portabilidade />,
      TERMO_REFINANCIAMENTO: <Refinanciamento />,
      PUBLICO_VULNERAVEL: <PublicoVulneravel />,
      CCB_CAPA: <CapaCCB />,
      SEGURO_PRESTAMISTA_REFINANCIAMENTO: <SeguroPrestamistaRefin />,
      AUTORIZACAO_LIQUIDACAO: <AutorizacaoLiquidacao />,
      CCB_PRIVADO: <CCBCtps />,
      CARTILHA_CREDITO_TRABALHADOR: <CartilhaCreditoTrabalhador />,
    }),
    [],
  )

  const { loading, documentoRevisao } = useSelector(
    (state: ApplicationState) => state.refinanciamento.documentosAssinatura,
  )
  const isPublicoVulneravel = documentoRevisao === 'PUBLICO_VULNERAVEL'
  const isAdf = documentoRevisao === 'ADF'

  useEffect(() => {
    BridgeService.tac({
      name: 'tela_termos_contratacao',
      actions: ['ver_termos'],
    })

    if (isApp) {
      Tag.enviarTagueamentoApp({
        screen: 'clt:refin:term',
        ref_type: '',
        content_action: 'Dado carregado',
        action_id: 'Termo de contratacao',
        section: 'term',
        sub_section: '',
        step: '',
        scenario: 'Termo de contratacao',
        ref_figma: '2',
      })
    } else {
      Tag.enviarTagueamentoWeb({
        element_action: 'page_loaded',
        element_name: 'Termo de contratacao',
        c_page: window.location.href,
        redirect_url: '',
        section_name: 'payrollloan:refin:term',
        section: 'term',
        sub_section: '',
        step: '',
        scenario: 'Termo de contratacao',
      })
    }
  }, [isApp])

  if (loading) return <Loading height="150px" />

  return (
    <>
      {isApp ? <Header showLeftIcon>Termo</Header> : <></>}
      <PageVisualizarPdf id="visualizar-documentos-assinatura">
        <PdfGrid ref={ref} isCartilha={isPublicoVulneravel} isAdf={isAdf} isWeb={!isApp}>
          {PdfAssinatura[documentoRevisao]}
        </PdfGrid>
      </PageVisualizarPdf>
    </>
  )
}
export default VisualizadorTermo
